import { render, staticRenderFns } from "./led.vue?vue&type=template&id=0a7e0946&scoped=true&"
import script from "./led.vue?vue&type=script&lang=js&"
export * from "./led.vue?vue&type=script&lang=js&"
import style0 from "./led.vue?vue&type=style&index=0&id=0a7e0946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e0946",
  null
  
)

export default component.exports